import api from './api';

const worksheetService = {
  // Worklist & KPI
  getWorklist: async (params = {}) => {
    const response = await api.get('/worksheet/worklist', { params });
    return response.data;
  },

  // Work Detail (Parameters, Ranges, Delta History, Critical Values)
  getWorkDetail: async (testId) => {
    const response = await api.get(`/worksheet/${testId}`);
    return response.data;
  },

  // Bench Testing Actions
  startWork: async (payload) => {
    const response = await api.post('/worksheet/start', payload);
    return response.data;
  },

  holdWork: async (payload) => {
    const response = await api.post('/worksheet/hold', payload);
    return response.data;
  },

  resumeWork: async (payload) => {
    const response = await api.post('/worksheet/resume', payload);
    return response.data;
  },

  repeatWork: async (payload) => {
    const response = await api.post('/worksheet/repeat', payload);
    return response.data;
  },

  rejectWork: async (payload) => {
    const response = await api.post('/worksheet/reject', payload);
    return response.data;
  },

  completeWork: async (payload) => {
    const response = await api.post('/worksheet/complete', payload);
    return response.data;
  },

  // Batch Processing
  createBatch: async (payload) => {
    const response = await api.post('/worksheet/batch', payload);
    return response.data;
  },

  // Templates
  getTemplates: async (params = {}) => {
    const response = await api.get('/worksheet/templates', { params });
    return response.data;
  },

  getTemplateById: async (id) => {
    const response = await api.get(`/worksheet/templates/${id}`);
    return response.data;
  },

  saveTemplate: async (payload) => {
    const response = await api.post('/worksheet/templates', payload);
    return response.data;
  },

  deleteTemplate: async (id) => {
    const response = await api.delete(`/worksheet/templates/${id}`);
    return response.data;
  },

  // Print & PDF
  getPrintPreview: async (payload) => {
    const response = await api.post('/worksheet/preview', payload);
    return response.data;
  },

  getPrintHtml: async (payload) => {
    const response = await api.post('/worksheet/print-html', payload, {
      responseType: 'text'
    });
    return response.data;
  },

  // Analyzers & Instruments
  getAnalyzers: async (subCategoryId = null) => {
    const response = await api.get('/worksheet/analyzers', {
      params: subCategoryId ? { subCategoryId } : {}
    });
    return response.data;
  },

  // AI-Like Smart Assist
  getSmartAssist: async (params = {}) => {
    const response = await api.get('/worksheet/smart-assist', { params });
    return response.data;
  },

  // Audit Trail
  getAuditTrail: async (entityId, entityType = 'WorkItem') => {
    const response = await api.get(`/worksheet/${entityId}/audit`, {
      params: { entityType }
    });
    return response.data;
  }
};

export default worksheetService;
